var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDocumentsinline = function SvgIconDocumentsinline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a7b8e3",
    d: "M6.944 5.685V1.442l4.244 4.243zm-5.4-5.4C.693.284 0 .978 0 1.826v12.346c0 .849.694 1.543 1.543 1.543h9.26c.848 0 1.543-.694 1.543-1.543v-9.26L7.716.285z"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDocumentsinline, _extends({
    svgRef: ref
  }, props));
});
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 16\"><g><g><g><g><path fill=\"#a7b8e3\" d=\"M6.944 5.685V1.442l4.244 4.243zm-5.4-5.4C.693.284 0 .978 0 1.826v12.346c0 .849.694 1.543 1.543 1.543h9.26c.848 0 1.543-.694 1.543-1.543v-9.26L7.716.285z\"></path></g></g></g></g></svg>";
export { ForwardRef as ReactComponent };